import styled, { keyframes } from 'styled-components';

// Keyframes para la animación del reloj de arena
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Keyframes para la animación de la barra de carga
const fillProgress = keyframes`
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 650px;
  text-align: center;
  position: relative;
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
`;

export const ModalSubtitle = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 25px;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-bottom: 30px;
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  height: 100%;
  background-color: #28a745; /* Color de progreso verde */
  width: ${props => props.progress}%; /* Se actualizará con el estado */
  border-radius: 4px;
  transition: width 0.5s ease-in-out; /* Transición suave para el progreso */
  /* animation: ${fillProgress} 15s linear infinite;  Puedes usar esto si quieres una animación continua e independiente del progreso controlado por estado */
`;

export const LoadingText = styled.p`
  font-size: 18px;
  color: #333;
  margin-bottom: 40px;
`;

export const SandglassIcon = styled.div`
  width: 50px;
  height: 50px;
  /* Puedes reemplazar esto con una imagen SVG o un icono de librería como Font Awesome */
  background-color: #007bff; /* Color de ejemplo para el icono */
  mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 14h-2v-4h-2V8h6v4h-2v4z"/></svg>') no-repeat center center;
  mask-size: contain;
  margin: 0 auto;
  animation: ${rotate} 2s linear infinite;
`;

export const ModalHead = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${prop => prop.setShowModal ? '0' : '30px'};

  svg {
    cursor: pointer;
  }
`;